import React from "react";
import { useTranslation } from "react-i18next";

import StudentPythonIDEWrapper from "../../../components/IDEs/wrappers/student/StudentPythonIDEWrapper";
import StudentSmoothyIDEWrapper from "../../../components/IDEs/wrappers/student/StudentSmoothyIDEWrapper";
import StudentWebIDEWrapper from "../../../components/IDEs/wrappers/student/StudentWebIDEWrapper";
import { IDE_TYPE } from "../../../constants/common";
import useAuth from "../../../hooks/useAuth";

const StudentMyCodingArea = () => {
  const user = useAuth();
  const { t } = useTranslation();
  // Simple mobile detection
  const isMobile = window.innerWidth < 768; // Tailwind's md breakpoint

  if (isMobile) {
    return (
      <div className="flex min-h-[calc(100vh-173px)] items-center justify-center px-4 text-center">
        <p className="text-lg font-semibold text-gray-700">📱 {t("please_open_this_page_in_web_view")}</p>
      </div>
    );
  }

  if (!user || !user.IDEType) return null; // Or <Loading />

  switch (user.IDEType) {
    case IDE_TYPE.SMOOTHY:
      return <StudentSmoothyIDEWrapper />;
    case IDE_TYPE.WEB:
      return <StudentWebIDEWrapper />;
    case IDE_TYPE.PYTHON:
      return <StudentPythonIDEWrapper />;
    default:
      return <div>Unsupported IDE type: {user?.IDEType}</div>;
  }
};

export default StudentMyCodingArea;
